import { getLocalizedString } from "owa-datetime-formatters-core";
import { format } from "owa-localize";
import { localizedFormatter } from "./localizedFormatter";
import { getShortUserDateFormat } from "./formatShortUserDate";
import type { OwaDate, GlobalCalendarLocale } from "owa-datetime";

/**
 * Gets a short version of the user's date format, with just weekday, day and month.
 */
export function getWeekDayShortUserDateFormat(dateFormat: string, _timeFormat: string): string {
    return format(getLocalizedString("weekDayDateFormat"), getShortUserDateFormat(dateFormat));
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
localizedFormatter(getWeekDayShortUserDateFormat);
export default defaultExport;
